// components/ProcessSection.jsx
import React, { useEffect } from 'react';
import './styles/processSection.css';

const ProcessSection = () => {
  const processSteps = [
    {
      number: "01",
      title: "Analyze",
      description: "Deep research and discovery to understand your goals and audience"
    },
    {
      number: "02",
      title: "Plan",
      description: "Strategic roadmap and architecture for optimal results"
    },
    {
      number: "03",
      title: "Create",
      description: "Pixel-perfect design and development with attention to detail"
    },
    {
      number: "04",
      title: "Optimize",
      description: "Performance tuning and refinement for perfection"
    },
    {
      number: "05",
      title: "Scale",
      description: "Growth strategies and continuous improvement"
    }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Animate progress line
          const progressLine = document.getElementById('progressLine');
          if (progressLine) {
            progressLine.style.width = '100%';
          }
          
          // Animate process items with clear delay
          const items = document.querySelectorAll('.process-item');
          items.forEach((item, index) => {
            setTimeout(() => {
              item.classList.add('animate');
            }, index * 200);
          });
          
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });

    const processSection = document.querySelector('#process');
    if (processSection) observer.observe(processSection);

    return () => observer.disconnect();
  }, []);

  return (
    <section id="process" className="process-section">
      <div className="section-container">
        <h2 className="section-title">Our Process</h2>
        <p className="section-subtitle">
          A proven methodology that transforms ideas into exceptional digital experiences
        </p>

        <div className="progress-line-container">
          <div className="progress-line" id="progressLine"></div>
        </div>

        <div className="process-grid">
          {processSteps.map((step, index) => (
            <div key={index} className="process-item">
              <div className="process-number">
                <span>{step.number}</span>
              </div>
              <div className="process-title">{step.title}</div>
              <p className="process-description">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;